// extracted by mini-css-extract-plugin
export var button = "_97-4";
export var hasDarkBackground = "_97-7";
export var hasLightBackground = "_97-6";
export var iconWrapper = "_97-0";
export var large = "_97-2";
export var medium = "_97-1";
export var small = "_97-5";
export var xsmall = "_97-3";